export const DATE_RANGE_FORMAT = 'D MMM YYYY';

// Used in mixpanel
export const DATE_TIME_TRACKING = 'YYYY-MM-DDTHH:MM:SS';
